import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=3558c656"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3558c656')) {
      api.createRecord('3558c656', component.options)
    } else {
      api.reload('3558c656', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=3558c656", function () {
      api.rerender('3558c656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw/components/Dialog.vue"
export default component.exports